import { buildModelManager } from "../builder.js";
const DefaultQaKnowledgeDocumentSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  domainTags: true,
  file: { url: true, mimeType: true, fileName: true },
  knowledgeBaseId: true,
  metadata: true,
  openaiFileId: true,
  syncStatus: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "qaKnowledgeDocument";
const pluralModelApiIdentifier = "qaKnowledgeDocuments";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaKnowledgeDocumentSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaKnowledgeDocumentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaKnowledgeDocumentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaKnowledgeDocumentSelection,
  operations
);
export {
  DefaultQaKnowledgeDocumentSelection,
  QaKnowledgeDocumentManager
};
//# sourceMappingURL=QaKnowledgeDocument.js.map
